import React, { type PropsWithChildren } from 'react'
import { type StyleProp, type ViewStyle } from 'react-native'
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated'
import { cn } from '~/lib/utils'

const duration = 1000

export type SkeletonProps = PropsWithChildren<{
  className?: string
  style?: StyleProp<ViewStyle>
}>

function Skeleton({ className, children, style: propsStyle }: SkeletonProps) {
  const sv = useSharedValue(1)

  React.useEffect(() => {
    sv.value = withRepeat(
      withSequence(withTiming(0.5, { duration }), withTiming(1, { duration })),
      -1
    )
  }, [sv])

  const style = useAnimatedStyle(() => ({
    opacity: sv.value,
  }))

  return (
    <Animated.View style={[propsStyle, style]} className={cn('rounded-md bg-muted', className)}>
      {children}
    </Animated.View>
  )
}

function LoadingSkeleton({
  isLoading,
  ...props
}: SkeletonProps & {
  isLoading?: boolean
}) {
  if (isLoading) {
    return <Skeleton {...props} />
  }

  return props.children
}

export { Skeleton, LoadingSkeleton }
